/**
* 头部菜单
*/
<template>
  <div class="nav-tem">
    <div class="logobox" style="cursor: pointer" @click="jumpHome">
      <img class="logoimg" src="../assets/img/logo.png" alt="">
    </div>
    <div style="display: flex;">
      <el-avatar src="https://cube.elemecdn.com/0/88/03b0d39583f48206768a7534e55bcpng.png" style="margin-top:10px;width:30px;height:30px"></el-avatar>
      <span style="line-height: 50px!important;color:#fff;width:70px;text-align:center;margin:0 10px">管理员</span>
      <div class="ii">
        <i class="el-icon-tuichu" style="cursor: pointer;color:#ffffff;" @click="exit" ></i>
      </div>
    </div>

    <!-- <p></p>
    <el-menu class="el-menu-demo no-border" mode="horizontal"  background-color="#25396f" text-color="#0f215d" active-text-color="#fff">
      <el-submenu index="1" class="submenu" popper-class="m-pop">
        <template slot="title">{{user.userRealName}}</template>
        <template slot="title">
          <img src="../assets/img/user.png" alt="">
        </template>
        <el-menu-item @click="exit()" index="2-3">退出</el-menu-item>
      </el-submenu>
    </el-menu>

    <el-dialog title="修改密码" :visible.sync="formVisible">
      <el-form ref="formData" :model="formData" :rules="rules">
        <el-form-item prop="password" label="新密码" label-width="80px">
          <el-input placeholder="请输入新密码" v-model="formData.password" type="password"></el-input>
        </el-form-item>
      </el-form>

      <p style="color: #e0231e;font-size: 12px;">*输入新密码及更改密码</p>

      <div slot="footer" class="dialog-footer">
        <el-button class="btn-submit" type="primary" @click="submitForm('formData')">确定</el-button>
        <el-button class="btn-cancel" @click="formVisible=false">取消</el-button>
      </div>
    </el-dialog> -->
  </div>

</template>
<script>
export default {
  name: 'navcon',
  data() {
    return {
      collapsed: true,
      imgshow: require('../assets/img/show.png'),
      imgsq: require('../assets/img/sq.png'),
      user: '',
      messageNum:0,
      messageContent:'',
      formData:{
        password:''
      },
      formVisible:false,
      rules:{
        password:[{required:true,message:'请输入密码',trigger:'blur'}]
      }
    }
  },
  // 创建完毕状态(里面是操作)
  created() {
    this.user=localStorage.getItem('username')
  },
  methods: {
    jumpHome(){
      this.$router.push({path:'/share/current'})
    },
    editPassword(){
      this.formVisible=true

    },
    // submitForm(formName){
    //   this.$refs[formName].validate((valid)=>{
    //     if (valid){
    //       let params={
    //         id:localStorage.getItem('userId'),
    //         token:localStorage.getItem('token'),
    //         password:this.formData.password
    //       }
    //       updatePsw(params).then(res=>{
    //         if(res.errno===0){
    //           this.$message({
    //             type:'success',
    //             message:res.data
    //           })
    //           this.formVisible=false
    //
    //         }
    //         else{
    //           this.$message.error(res.data)
    //         }
    //       })
    //     }
    //   })
    // },
    getMessageList(){
      getMessage().then(res=>{
        if(res.errno===0){
          this.messageNum=res.data.count
          this.messageContent=res.data.message
        }
      })
    },
    // 退出登录
    exit() {
      this.$confirm('退出登录, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          setTimeout(() => {
            this.$store.commit('logout', 'false')
            localStorage.setItem('token','')
            this.$router.push({ path: '/login' })
            this.$message({
              type: 'success',
              message: '已退出登录!'
            })
          }, 1000)
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消'
          })
        })
    },
  },
  mounted(){
    // this.getMessageList()
  }
}
</script>
<style scoped>
.nav-tem{
  display: flex;
  justify-content:space-between;
  background: #25396f;
  height: 50px;
}
.ii i {
  color:#888c9c;
  font-size: 30px;
  margin-top:22%;
  margin-right: 30px;
}
.el-menu-vertical-demo:not(.el-menu--collapse) {
  border: none;
}
.submenu {
  float: right;
}
.el-menu.el-menu--horizontal.no-border{
  border-bottom: none;
}
.m-alert{
  border-right: 2px solid #f9f8fd;
}
.nav-tem >>> .el-menu-demo.el-menu--horizontal>.el-menu-item{
  height: 50px;
  line-height: 50px;
}
.nav-tem >>>  .el-menu-demo.el-menu--horizontal>.el-submenu .el-submenu__title{
  height: 50px;
  line-height: 50px;
}
.nav-tem>>>.el-badge__content.is-fixed{
  top: 16px;
  right: 10px;
}
.nav-tem >>> .el-badge__content{
  height: 12px;
  line-height: 12px;
  background-color: #e0231e;
}

</style>
<style>
.m-pop  .el-menu--popup{
  min-width: 128px !important;
  padding: 0;
}
.m-pop.el-menu--horizontal .el-menu-item:not(last-child){
  text-align: center;
  background-color: #f9f8fd !important;
  border-bottom: 1px solid #0f215d;
}
.m-pop.el-menu--horizontal .el-menu-item:last-child{
  border-bottom: 1px solid transparent;
}
.m-pop.el-menu--horizontal .el-menu-item:not(.is-disabled):hover{
  background-color: #0f215d !important;
  color: #fff !important;
}
.m-alert .el-submenu__icon-arrow.el-icon-arrow-down{
  display: none;
}
</style>



// WEBPACK FOOTER //
// src/components/navcon.vue